export const REQUEST_SUBSCRIBERS = 'REQUEST_SUBSCRIBERS'
export const RECEIVE_SUBSCRIBERS = 'RECEIVE_SUBSCRIBERS'
export const ADD_SUBSCRIBER = 'ADD_SUBSCRIBER'
export const REMOVE_SUBSCRIBER = 'REMOVE_SUBSCRIBER'

const requestSubscribers = () => ({
  type: REQUEST_SUBSCRIBERS
})

const receiveSubscribers = subscribers => ({
  type: RECEIVE_SUBSCRIBERS,
  subscribers
})

export const addSubscriber = subscriber => ({
  type: ADD_SUBSCRIBER,
  subscriber
})

const removeSubscriber = id => ({
  type: REMOVE_SUBSCRIBER,
  payload: {
    id
  }
})

export const fetchAddSubscriber = (personId, subscriber) => dispatch => {
  return fetch(process.env.REACT_APP_BASE_URL + '/subscribers/add_person_subscription',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ personId, subscribedToId: subscriber.id })
    })
    .then(
      response => dispatch(addSubscriber(subscriber)),
      error => console.log('An error occurred', error)
    )
}

export const fetchSubscribers = personId => dispatch => {
  dispatch(requestSubscribers())

  return fetch(process.env.REACT_APP_BASE_URL + '/subscribers/get_subscribers',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ personId })
    })
    .then(
      response => response.json(),
      error => console.log('An error occurred', error)
    )
    .then(json => dispatch(receiveSubscribers(json)))
}

export const fetchUnsubscribe = (personId, subscribedToId) => dispatch => {
  dispatch(requestSubscribers())

  return fetch(process.env.REACT_APP_BASE_URL + '/subscribers/remove_person_subscription',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ personId, subscribedToId })
    }).then(() => dispatch(removeSubscriber(subscribedToId)))
}
